import {
  FORTA_BLACK,
  FORTA_BLUE,
  FORTA_ERROR,
  FORTA_GRAY2,
  FORTA_WHITE,
} from '../../../utils/colors';

export const NEW_SESSION_INFO_ROOT_SX = { textAlign: 'left', backgroundColor: FORTA_WHITE };

export const NEW_SESSION_INFO_CONTENT_SX = { pt: 3.75, pb: 2 };

export const NEW_SESSION_TOP_GRID_SX = {
  mb: 2.5,
  '& > .MuiGrid-item': {
    pb: 1.5,
  },
};

export const NEW_SESSION_GRID_SX = {
  '& > .MuiGrid-item': {
    pb: 1.5,
  },
};

export const CLIENT_OPTION_DESCRIPTION_SX = {
  px: 1,
  ml: 1,
  borderRadius: '4px',
  color: FORTA_WHITE,
  fontWeight: 700,
  backgroundColor: FORTA_BLUE.light1,
};

export const FORM_TOOLTIP_SX = { inset: 'auto auto -6px 0px', opacity: 0.9 };

export const TIME_TOOLTIP_SX = { ...FORM_TOOLTIP_SX, mb: 10 };

export const NEW_SESSION_SELECT_BLACK_BORDER_SX = {
  '& .MuiSelect-select.MuiInputBase-input': {
    border: `1px solid ${FORTA_BLACK} !important`,
    '&:focus-within': {
      border: `1px solid ${FORTA_BLACK} !important`,
    },
  },
};

export const NEW_SESSION_OUTLINED_BLACK_BORDER_SX = {
  '& .MuiOutlinedInput-notchedOutline': {
    border: `1px solid ${FORTA_BLACK} !important`,
  },
  '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    border: `1px solid ${FORTA_BLACK} !important`,
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: `1px solid ${FORTA_BLACK} !important`,
  },
  '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
    border: `1px solid ${FORTA_BLACK} !important`,
  },
};

export const START_BUTTON_WRAPPER_SX = {
  display: 'flex',
  justifyContent: { xs: 'flex-start', lg: 'flex-end' },
};

export const START_BUTTON_SX = {
  width: { xs: '100%', sm: '100%', lg: '100%' },
  minWidth: 100,
  height: 40,
  fontSize: 14,
  border: 'none',
  backgroundColor: FORTA_BLUE.primary,
  '&:hover': { backgroundColor: FORTA_BLUE.primary },
  '&.Mui-disabled': {
    backgroundColor: FORTA_BLUE.light2,
    color: FORTA_WHITE,
  },
};

export const EVV_VERIFICATION_BUTTON_WRAPPER_SX = {
  display: 'flex',
  height: '100%',
  alignItems: 'center',
  justifyContent: 'flex-end',
};

export const EVV_VERIFICATION_BUTTON_SX = {
  ...START_BUTTON_SX,
  width: '100%',
};

export const WARNING_WRAPPER_SX = { display: 'flex', justifyContent: 'flex-end' };

export const BAY_WARNING_TEXT_SX = { ml: 1, fontSize: '14px' };

export const BAY_WARNING_CONTAINER_SX = {
  mt: 1,
  mb: -2,
  backgroundColor: 'transparent',
  p: 0,
};

export const DELETE_BUTTON_WRAPPER_SX = {
  display: 'flex',
  height: '100%',
  alignItems: 'center',
  justifyContent: 'flex-end',
};

export const DELETE_BUTTON_SX = {
  p: 1,
  ml: 2,
  fontSize: 16,
  borderRadius: '8px',
  color: FORTA_ERROR,
  border: `1px solid ${FORTA_ERROR}`,
  '&:hover': {
    opacity: 1,
  },
};

export const SESSION_BREAK_CARD_SX = {
  mt: 2.5,
  width: { xs: '100%', md: 640 },
  borderRadius: '8px',
  border: `1px solid ${FORTA_BLUE.light2}`,
  boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.18)',
  p: 2,
  textAlign: 'left',
};

export const SESSION_BREAK_CHECKBOX_LABEL_SX = {
  width: '100%',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  textAlign: 'left',
};

export const SESSION_BREAK_FIELDS_SX = {
  mt: 2,
  display: 'grid',
  gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
  gap: 2,
};

export const ADD_BREAK_BUTTON_WRAPPER_SX = {
  mt: 2,
  display: 'flex',
  justifyContent: 'flex-end',
};

export const ADD_BREAK_BUTTON_SX = {
  minWidth: 150,
  height: 40,
  fontSize: 14,
  border: 'none',
  backgroundColor: FORTA_BLUE.primary,
  '&:hover': { backgroundColor: FORTA_BLUE.primary },
  '&.Mui-disabled': {
    backgroundColor: FORTA_BLUE.light2,
    color: FORTA_WHITE,
  },
};

export const SESSION_BREAK_LIST_SX = {
  mt: 2,
  borderTop: `1px solid ${FORTA_GRAY2}`,
};

export const SESSION_BREAK_ROW_SX = {
  minHeight: 54,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 2,
  px: 1,
  backgroundColor: FORTA_BLUE.light3,
  '&:nth-of-type(odd)': {
    backgroundColor: FORTA_BLUE.light2,
  },
};

export const SESSION_BREAK_ACTIONS_SX = {
  display: 'flex',
  gap: 1,
};

export const SESSION_BREAK_ICON_BUTTON_SX = {
  width: 40,
  height: 40,
  borderRadius: '8px',
  border: `1px solid ${FORTA_BLUE.primary}`,
  color: FORTA_BLUE.primary,
};

export const EVENT_WARNING_DIALOG_TITLE_SX = {
  color: FORTA_BLUE.primary,
  fontWeight: 500,
};

export const EVENT_WARNING_DIALOG_SX = {
  maxHeight: '85vh',
  height: 'auto',
  width: '650px',
  maxWidth: '650px',
};

export const EVENT_WARNING_CONTENT_SX = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  px: 1,
  py: 4,
};

export const EVENT_WARNING_TEXT_SX = {
  textAlign: 'center',
  fontSize: 20,
  fontWeight: 500,
};

export const EVENT_WARNING_DETAIL_TEXT_SX = {
  textAlign: 'center',
  fontSize: 21,
  fontWeight: 500,
  mt: 2,
  mb: 1,
};
